import React from "react";
import PropTypes from "prop-types";

import AdminTeamPermissionsPanel from "../../../../TeamManagement/AdminTeamPermissionsPanel";

const CompanyTeamPermissionsTab = ({ companyId }) => (
  <AdminTeamPermissionsPanel companyId={companyId} />
);

CompanyTeamPermissionsTab.propTypes = {
  companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default CompanyTeamPermissionsTab;
